// @ts-nocheck
/**
 * @deprecated Use meshToPolyData from @itk-wasm/mesh-to-poly-data instead
 */
async function meshToPolyData(webWorker, mesh) {
    throw new Error('This function has been migrated to the @itk-wasm/mesh-to-poly-data package.');
}
export default meshToPolyData;
//# sourceMappingURL=mesh-to-poly-data.js.map